import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAMEM_lOqsqAMPD9GRZBUlSTkFOvuXSsyM",
  authDomain: "mediglove-3ff8b.firebaseapp.com",
  projectId: "mediglove-3ff8b",
  storageBucket: "mediglove-3ff8b.firebasestorage.app",
  messagingSenderId: "85484466823",
  appId: "1:85484466823:web:9cfc1598ec7a0ca1307e22"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app;
